import user from '@/model/user';
import auth from '@/model/auth';
import error from '@/model/error';
import popup from '@/model/popup';
import store from '@/store';
import Vue from 'vue';
import VueRouter from 'vue-router';
import NotFound from '../pages/NotFound.vue';
import MainRoutes from './modules/main';
import PersonalRoutes from './modules/personal';
import AdminRoutes from './modules/admin';
import AuthRoutes from './modules/auth';
import ProjectRoutes from './modules/project';
import CompanyRoutes from './modules/company';
import NewsRoutes from './modules/news';
import AffiliateRoutes from './modules/affiliate';
import ExchangeRoutes from './modules/exchange';
import SupplierRoutes from './modules/supplier';

Vue.use(VueRouter);

/**
 * (Claude) Маршруты, открытые пользователю с карточкой поставщика (ТЗ 6.1): кабинет поставщика и
 * уведомления — пункт меню кабинета. Любой другой маршрут ведёт на список запросов.
 */
const SUPPLIER_ROUTE_NAMES = [
  ...SupplierRoutes.map((route) => route.name),
  'notifications',
  'notification-settings',
];

/**
 * (Claude) Перенаправление поставщика в кабинет (ТЗ 6.1): признак поставщика — наличие карточки в
 * ответе о текущем пользователе (12.3). Выполняется после загрузки пользователя.
 */
function supplierRedirect(to) {
  const isSupplier = !!store.state.auth.user?.supplier;
  if (!isSupplier || to.meta.needAuth === false) return null;
  if (to.name && SUPPLIER_ROUTE_NAMES.includes(to.name)) return null;
  return { name: 'supplier-requests' };
}

const routes = [
  ...MainRoutes,
  ...AdminRoutes,
  ...AuthRoutes,
  ...PersonalRoutes,
  ...ProjectRoutes,
  ...CompanyRoutes,
  ...NewsRoutes,
  ...AffiliateRoutes,
  ...ExchangeRoutes,
  ...SupplierRoutes,
  { path: '*', component: NotFound },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition ?? { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (store.state.closePrevent.enabled) {
    next(false);
    const question = 'У вас есть не сохраненные данные. Вы действительно хотите покинуть страницу?';
    const answer = await popup.addConfirm(question);
    if (!answer) {
      return;
    }
    store.commit('closePrevent/disable');
  }

  // снимаем блокировку прокрутки, оставленную попапом, удалением стиля, а не значением 'auto':
  // при html { overflow-y: scroll } body с overflow: auto становится отдельной областью прокрутки,
  // которая сама не прокручивается, и position: sticky перестаёт работать на всех страницах
  document.body.style.removeProperty('overflow');
  error.clear();

  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (to.meta.needAuth === false || store.state.auth.user) {
    next(supplierRedirect(to) ?? undefined);
    return;
  }

  user.fetchSelf()
    .then(() => { next(supplierRedirect(to) ?? undefined); })
    .catch(() => {
      auth.goToRouteAfterLogin(to.fullPath);
      next({ name: 'auth-login' });
    });
});

export default router;
